export default __webpack_public_path__ + "static/media/NumberListIcon.cd63fb2c.svg";